<div id="wrap" class="practiceList-bgblue">
	<div class="common-back-btn-sight"  (click)="close();" *ngIf="isOpenClass==0 && type!== 'huatek'&&!isTencent">
		<span>×</span>
	</div>

	<div id="head_wrap" class="fontSize18">
		情景模拟
	</div>

	<!-- 提醒 -->
	<component-tip *ngIf="isShowToast" [type]="'toast'" [desText]="promptText" [cancelText]="''" [sureText]="''" ></component-tip>

	  <div *ngIf="practiceList">
	    <div class="practiceList-listeImgItem" [ngStyle]="{'background-image': practice.extends ? practice.extends.bg : '' }" *ngFor="let practice of practiceList;let i = index" (click)="goToNextStep(practice)">
	      <div class="practiceList-listeImgItemHead-Img">
	        <img *ngIf="practice.extends && practice.extends.userPhoto != ''" src="{{practice.extends.userPhoto}}" class="practiceList-icon-sepcial"  />
	        <div *ngIf="practice.status == 2" class="practice-status">
	          	已完成
	        </div>
	        <div *ngIf="practice.momentsList.length > 0" class="momentImg" (click)="momentView(practice.momentsList,$event)">
					<img [src]="'assets/picture/casepracticemoment/' + practice.momentsList[0] + '.png'"  />
					<div class="viewtip" *ngIf="showToast && toastIndex == i">点击图标查看“难忘瞬间”</div>
			</div>
	      </div>
	      <div class="practiceList-listeImgItemHead fontSize16">
	        {{practice.title}}<div class="flagStatus" *ngIf="practice.phaseNum">共分{{practice.phaseNum}}个阶段</div>
	      </div>
	      <div class="practiceList-listeImgItemContent fontSize14 lineHeight21">
	        <span style="font-size: 12px;">{{practice.description}}</span>
	        <div class="entryBtn">进入</div>
	      </div>
	    </div>
	  </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&isShowQuestionnaire&&!isTencent">
      <components-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></components-approach>
    </div>

    <div class="approachModuleWrap" [ngClass]="type === 'huatek'? 'active':'' " *ngIf="!isCustomLock&&isShowApproach&&showGoToSurveyBtn&&isOpenClass==0&&!isShowQuestionnaire&&!isTencent">
      <components-approach [theme]="approachTheme" [isFirst]="isShowQuestionnaire" (onGoCourse)="goToPostSurvey()"></components-approach>
    </div>

</div>
<component-momentview *ngIf="showMoment" [momentList]="momentList" (onExit)="momentExit()"></component-momentview>
<component-questionnaire [learningPathMetaId]="learningPathMetaId" [isShowQuestionnaire]="isShowQuestionnaire && !type&&!isTencent" (onExit)="closeQuestionnaire()"></component-questionnaire>



// WEBPACK FOOTER //
// ./src/app/case-practice-executive-list/case-practice-executive-list.component.html